(function () {
  'use strict';

  var instances = new WeakMap();

  function initAll() {
    if (!window.THREE) {
      window.setTimeout(initAll, 60);
      return;
    }

    document.querySelectorAll('[data-exn-footer-earth]').forEach(function (root) {
      if (instances.has(root)) return;
      instances.set(root, createEarth(root));
    });
  }

  function createEarth(root) {
    var starsInstance = createProcessStars(root);
    var canvas = root.querySelector('#earth, .exn-footer-earth__canvas');
    if (!canvas) return { destroy: function () {} };

    var lineColor = root.dataset.lineColor || '#f7f7f2';
    var fogColor = root.dataset.fogColor || '#050505';
    var mapUrl = root.dataset.mapUrl || 'https://mapplix.github.io/earth/earth.png';
    var alive = true;
    var frame = null;
    var radius = 200;
    var W = Math.max(1, root.clientWidth);
    var H = Math.max(1, root.clientHeight);
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var targetRotX = 0;
    var targetRotY = 0;
    var currentRotX = 0;
    var currentRotY = 0;
    var drag = null;

    var renderer;
    // Options d'origine (marchent sur la grande majorité des navigateurs).
    try {
      renderer = new THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
        canvas: canvas,
        preserveDrawingBuffer: true
      });
    } catch (err) {
      // WebGL réellement indisponible (bloqueur, accélération GPU désactivée) :
      // on masque proprement la section pour ne jamais laisser une zone vide.
      root.setAttribute('data-exn-earth-fallback', 'true');
      console.warn('[exn-footer-earth] WebGL indisponible : section masquée.', err);
      return { destroy: function () {} };
    }
    renderer.setPixelRatio(dpr);
    renderer.setSize(W, H, false);
    renderer.setClearColor(0x000000, 0);

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(18, W / H, 1, 10000);
    camera.position.z = 1700;

    var world = new THREE.Group();
    var earth = new THREE.Group();
    earth.rotation.x = 23 / 180 * Math.PI;
    world.add(earth);
    scene.add(world);

    var globe = new THREE.Mesh(
      new THREE.IcosahedronGeometry(radius * 0.99, 5),
      new THREE.MeshBasicMaterial({
        color: fogColor,
        transparent: true,
        opacity: 0.98,
        depthWrite: true
      })
    );
    earth.add(globe);

    var rim = new THREE.Mesh(
      new THREE.SphereGeometry(radius * 1.012, 64, 32),
      new THREE.MeshBasicMaterial({
        color: lineColor,
        transparent: true,
        opacity: 0.12,
        side: THREE.BackSide,
        blending: THREE.AdditiveBlending,
        depthWrite: false
      })
    );
    earth.add(rim);

    var landGeometry = null;
    var landGlowGeometry = null;
    var landMaterial = new THREE.PointsMaterial({
      color: lineColor,
      size: 0.82,
      sizeAttenuation: false,
      transparent: true,
      opacity: 0.96,
      blending: THREE.AdditiveBlending,
      depthWrite: false
    });
    var landGlowMaterial = new THREE.PointsMaterial({
      color: lineColor,
      size: 1.72,
      sizeAttenuation: false,
      transparent: true,
      opacity: 0.08,
      blending: THREE.AdditiveBlending,
      depthWrite: false
    });

    loadLandPoints(mapUrl, radius * 1.018, function (positions, glowPositions) {
      if (!alive) return;

      landGeometry = new THREE.BufferGeometry();
      landGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(positions), 3));
      earth.add(new THREE.Points(landGeometry, landMaterial));

      landGlowGeometry = new THREE.BufferGeometry();
      landGlowGeometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(glowPositions), 3));
      earth.add(new THREE.Points(landGlowGeometry, landGlowMaterial));
    });

    function resizeIfNeeded() {
      var nextW = Math.max(1, Math.floor(root.clientWidth));
      var nextH = Math.max(1, Math.floor(root.clientHeight));
      var nextDpr = Math.min(window.devicePixelRatio || 1, 2);
      if (nextW === W && nextH === H && nextDpr === dpr) return;

      W = nextW;
      H = nextH;
      dpr = nextDpr;
      renderer.setPixelRatio(dpr);
      renderer.setSize(W, H, false);
      camera.aspect = W / H;
      camera.updateProjectionMatrix();
      applyResponsiveScale();
    }

    function applyResponsiveScale() {
      var scale = W < 760 ? Math.max(0.5, Math.min(0.82, W / 720)) : 1;
      world.scale.set(scale, scale, scale);
    }

    applyResponsiveScale();

    function pointerDown(event) {
      drag = {
        x: event.clientX,
        y: event.clientY,
        rx: targetRotX,
        ry: targetRotY
      };
      if (canvas.setPointerCapture) canvas.setPointerCapture(event.pointerId);
    }

    function pointerMove(event) {
      if (!drag) return;
      targetRotY = drag.ry + (event.clientX - drag.x) * 0.004;
      targetRotX = Math.max(-0.55, Math.min(0.55, drag.rx + (event.clientY - drag.y) * 0.003));
    }

    function pointerUp(event) {
      drag = null;
      if (canvas.releasePointerCapture) canvas.releasePointerCapture(event.pointerId);
    }

    canvas.addEventListener('pointerdown', pointerDown);
    canvas.addEventListener('pointermove', pointerMove);
    canvas.addEventListener('pointerup', pointerUp);
    canvas.addEventListener('pointercancel', pointerUp);

    var observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          root.dataset.exnEarthVisible = entries[0] && entries[0].isIntersecting ? 'true' : 'false';
        }, { rootMargin: '180px' })
      : null;

    if (observer) observer.observe(root);
    root.dataset.exnEarthVisible = 'true';

    function animate() {
      if (!alive) return;
      frame = requestAnimationFrame(animate);
      if (root.dataset.exnEarthVisible === 'false') return;

      resizeIfNeeded();
      if (!drag) targetRotY += 0.0016;
      currentRotX += (targetRotX - currentRotX) * 0.055;
      currentRotY += (targetRotY - currentRotY) * 0.055;
      world.rotation.x = currentRotX;
      earth.rotation.y = currentRotY;
      renderer.render(scene, camera);
    }

    animate();

    return {
      destroy: function () {
        alive = false;
        starsInstance.destroy();
        if (frame) cancelAnimationFrame(frame);
        if (observer) observer.disconnect();
        canvas.removeEventListener('pointerdown', pointerDown);
        canvas.removeEventListener('pointermove', pointerMove);
        canvas.removeEventListener('pointerup', pointerUp);
        canvas.removeEventListener('pointercancel', pointerUp);
        globe.geometry.dispose();
        globe.material.dispose();
        rim.geometry.dispose();
        rim.material.dispose();
        if (landGeometry) landGeometry.dispose();
        if (landGlowGeometry) landGlowGeometry.dispose();
        landMaterial.dispose();
        landGlowMaterial.dispose();
        renderer.dispose();
      }
    };
  }

  function loadLandPoints(url, radius, done) {
    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = function () {
      var scratch = document.createElement('canvas');
      var w = scratch.width = image.naturalWidth || image.width;
      var h = scratch.height = image.naturalHeight || image.height;
      var ctx = scratch.getContext('2d', { willReadFrequently: true });
      var positions = [];
      var glowPositions = [];
      var step = Math.max(2, Math.round(w / 700));

      ctx.drawImage(image, 0, 0, w, h);
      var data = ctx.getImageData(0, 0, w, h).data;

      for (var y = 0; y < h; y += step) {
        for (var x = 0; x < w; x += step) {
          var idx = (y * w + x) * 4;
          var alpha = data[idx + 3];
          var light = (data[idx] + data[idx + 1] + data[idx + 2]) / 3;

          if (alpha < 24 || light < 168) continue;
          if (Math.random() > 0.82) continue;

          var lon = ((x + (Math.random() - 0.5) * step * 0.28) / w) * Math.PI * 2 - Math.PI;
          var lat = Math.PI / 2 - ((y + (Math.random() - 0.5) * step * 0.28) / h) * Math.PI;
          var cosLat = Math.cos(lat);
          var px = -radius * cosLat * Math.cos(lon);
          var py = radius * Math.sin(lat);
          var pz = radius * cosLat * Math.sin(lon);

          positions.push(px, py, pz);
          if (Math.random() > 0.36) glowPositions.push(px, py, pz);
        }
      }

      done(positions, glowPositions);
    };
    image.src = url;
  }

  function createProcessStars(root) {
    var canvas = root.querySelector('.exn-footer-earth__stars');
    if (!canvas) return { destroy: function () {} };

    var ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return { destroy: function () {} };

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var alive = true;
    var raf = null;
    var w = 0;
    var h = 0;
    var dpr = 1;
    var stars = [];

    function resize() {
      dpr = Math.max(1, Math.min(2, window.devicePixelRatio || 1));
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = Math.floor(w * dpr);
      canvas.height = Math.floor(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

      var area = w * h;
      var count = Math.max(90, Math.min(260, Math.floor(area / 12000)));
      stars = new Array(count).fill(0).map(function () {
        return {
          x: Math.random() * w,
          y: Math.random() * h,
          r: Math.random() * 1.2 + 0.2,
          a: Math.random() * 0.54 + 0.12,
          tw: Math.random() * 0.02 + 0.006,
          s: Math.random() * 0.2 + 0.045
        };
      });
    }

    function draw() {
      if (!alive) return;

      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < stars.length; i++) {
        var st = stars[i];
        st.a += st.tw * (Math.random() > 0.5 ? 1 : -1);
        st.a = Math.max(0.1, Math.min(0.88, st.a));
        st.y += st.s;
        if (st.y > h + 10) {
          st.y = -10;
          st.x = Math.random() * w;
        }

        ctx.globalAlpha = st.a;
        ctx.beginPath();
        ctx.arc(st.x, st.y, st.r, 0, Math.PI * 2);
        ctx.fillStyle = '#fff';
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      raf = requestAnimationFrame(draw);
    }

    resize();
    if (!reduce) draw();
    window.addEventListener('resize', resize);

    return {
      destroy: function () {
        alive = false;
        if (raf) cancelAnimationFrame(raf);
        window.removeEventListener('resize', resize);
      }
    };
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-exn-footer-earth]');
    if (!root || !instances.has(root)) return;
    instances.get(root).destroy();
    instances.delete(root);
  });

  if (document.readyState !== 'loading') initAll();
})();
